import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestEvidenceSourceSchema = z.object({
  researchRequestEvidenceSourceId: PrimaryKeySchema,
  researchRequestEvidenceId: PrimaryKeySchema,
  sourceId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestEvidenceSource = z.infer<
  typeof ResearchRequestEvidenceSourceSchema
>;

export const ResearchRequestEvidenceSourcesSchema = z.array(
  ResearchRequestEvidenceSourceSchema,
);

export type ResearchRequestEvidenceSources = z.infer<
  typeof ResearchRequestEvidenceSourcesSchema
>;

export const ResearchRequestEvidenceSourcesQuerySchema = z.object({
  researchRequestEvidenceIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestEvidenceSourceIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  sourceIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type ResearchRequestEvidenceSourcesQuery = z.infer<
  typeof ResearchRequestEvidenceSourcesQuerySchema
>;

export const CreateResearchRequestEvidenceSourceSchema =
  ResearchRequestEvidenceSourceSchema.pick({
    researchRequestEvidenceId: true,
    sourceId: true,
  });

export type CreateResearchRequestEvidenceSource = z.infer<
  typeof CreateResearchRequestEvidenceSourceSchema
>;
